import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './translations';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'de', // set locale
  fallbackLocale: 'de',
  messages, // set locale messages
  silentTranslationWarn: process.env.NODE_ENV === 'production',
});
